<template>
  <el-dialog
    :title="title"
    width="800px"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="form"
      :inline="true"
      label-position="right"
      :model="form"
      :rules="formRules"
      label-width="95px"
    >
      <div class="form-title">客户信息</div>
      <el-form-item class="form-item-half" label="手机号" prop="mobile">
        <el-input
          :disabled="isDetail"
          size="mini"
          maxlength="11"
          placeholder="请输入手机号"
          v-model="form.mobile"
          @input="handleChangeMobile"
          @blur="handleUpdateMobile"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-item-half" label="姓名" prop="name">
        <el-input
          :disabled="isDetail"
          size="mini"
          maxlength="30"
          placeholder="请输入姓名"
          v-model="form.name"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-item-half" label="性别" prop="gender">
        <el-radio-group v-model="form.gender" :disabled="isDetail">
          <el-radio v-for="item in genderList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="form-item-half" label="微信号" prop="wechat">
        <el-input
          :disabled="isDetail"
          size="mini"
          maxlength="30"
          placeholder="请输入微信号"
          v-model="form.wechat"
        ></el-input>
      </el-form-item>
      <div class="form-title">到店记录</div>
      <el-form-item class="form-item-half" label="到店类型" prop="arrivalType">
        <el-select
          size="mini"
          v-model="form.arrivalType"
          placeholder="请选择到店类型"
          :disabled="isDetail || (form.mobile && isGetCustInfoByPhone)"
        >
          <el-option
            v-for="item in customerArrivalTypes"
            :key="item.dataValue"
            :label="item.dataDisplay"
            :value="item.dataValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="form-item-half" label="陪同情况" prop="accompanyType">
        <el-select
          size="mini"
          v-model="form.accompanyType"
          placeholder="请选择"
          :disabled="isDetail"
          @change="handleChangeAccompanyType"
        >
          <el-option
            v-for="item in customerAccompanyTypes"
            :key="item.dataValue"
            :label="item.dataDisplay"
            :value="item.dataValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isHasAccompany" class="form-item-half" label="陪同人数" prop="accompanyNum">
        <el-input-number size="mini" v-model="form.accompanyNum" :min="1" :max="100" :step="1" step-strictly :disabled="isDetail"></el-input-number>
        <span class="accompany-num-text">人</span>
      </el-form-item>
      <div class="date-box">
        <el-form-item label="到店时间" prop="arrivalDate">
          <el-date-picker
            v-model="form.arrivalDate"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            :disabled="isDetail" 
            :pickerOptions="{
              disabledDate(time) {
                return time.getTime() > new Date() || time.getTime() < new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
              }
            }"
            @change="handleChangeArrivalDate"
          >
          </el-date-picker>
        </el-form-item>
        <div class="separation">-</div>
        <el-form-item prop="arrivalMoment">
          <el-time-select
            :disabled="isDetail" 
            placeholder="请选择时间"
            v-model="form.arrivalMoment"
            :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '23:55',
              maxTime: arrivalMomentMaxTime
            }" 
          >
          </el-time-select>
        </el-form-item>
      </div>
      <el-form-item class="form-item-half" label="预约人员" prop="reservationStaff">
        <el-select
          size="mini"
          v-model="form.reservationStaff"
          filterable
          placeholder="请选择"
          :disabled="isDetail"
        >
          <el-option
            v-for="item in assignMembers"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="form-item-half" label="接待人员" prop="receptionStaff">
        <el-select
          size="mini"
          v-model="form.receptionStaff"
          filterable
          placeholder="请选择"
          :disabled="isDetail"
        >
          <el-option
            v-for="item in assignMembers"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="form-item-half" label="到店目的" prop="arrivalPurpose">
        <el-select
          :disabled="isDetail"
          :collapse-tags="!isDetail"
          multiple
          size="mini"
          v-model="form.arrivalPurpose"
          placeholder="请选择"
          @visible-change="handleVisibleChangeArrivalPurpose"
        >
          <el-option
            v-for="item in customerArrivalPurposes"
            :key="item.dataValue"
            :label="item.dataDisplay"
            :value="item.dataValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isOtherReason" class="form-item-half" label="其他目的" prop="otherPurpose">
        <el-input size="mini" maxlength="200" placeholder="请输入" v-model="form.otherPurpose" :disabled="isDetail">
        </el-input>
      </el-form-item>
    </el-form>
    <span v-if="!isDetail" slot="footer" class="dialog-footer">
      <el-button type="text" :loading="isSubmitting" @click="handleConfirm">确 定</el-button>
      <el-button type="text" @click="handleClose">取 消</el-button>
    </span>
    <el-dialog
      :visible.sync="canLeaveRegister"
      :close-on-press-escape="false"
      :close-on-click-modal="false"      
      :before-close="() => { canLeaveRegister=false }"
      append-to-body
      width="30%"
      title="提示"
    >
      <div class="register-info">
        <div>已有到店记录，且尚未离店</div>
        <div>原登记人：{{ verifyArrivalInfo.registerStaffName }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="verifyArrivalInfo.canRegisterLeave===CONSTANT_0" type="text" @click="handleLeaveRegister">去登记离店</el-button>
        <el-button type="text" @click="canLeaveRegister=false">取 消</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { 
  genderList,
  conditionSelectionList,
  CONSTANT_99,
  CONSTANT_1,
  CONSTANT_0,
  getDateTime,
  accompanyTypeHasNum
} from '../static/form-options'
import { mobileReg, arrivalFormRules } from '../static/form-rules';
import dayjs from 'dayjs';

export default {
  name: 'CustomerRecord',
  components: {
    // ZFormItem
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    assignMembers: {
      type: Array,
      default: () => []
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    flowId: {
      type: Number,
      default: null
    }
  },
  // model: {
  //   prop: 'visible',
  //   event: 'change'
  // },
  data() {
    return {
      CONSTANT_0,
      accompanyTypeHasNum: accompanyTypeHasNum,
      genderList,
      conditionSelectionList,
      form: {
        name: '', // 客户信息
        gender: null, // 性别
        mobile: '', // 手机号
        wechat: '', // 微信号
        arrivalType: CONSTANT_1,// 到店类型
        accompanyType: null,// 陪同情况
        accompanyNum: null,
        arrivalDate: '',// 到店日期
        arrivalMoment: '',// 到店时间
        reservationStaff: null,// 预约人员
        receptionStaff: null,// 接待人员
        arrivalPurpose: [],// 到店目的
        otherPurpose: '',// 其他目的
      },
      formRules: arrivalFormRules,
      profile: this.$common.getDealer(),
      verifyArrivalInfo: {},
      canLeaveRegister: false,
      isSubmitting: false,
      customerArrivalTypes: [], // 到店类型
      isGetCustInfoByPhone: false, // 是否根据手机号获取到客档信息
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          // 到店类型
          this.customerArrivalTypes = this.baseInfo.customerArrivalTypes
          const { date, moment } = getDateTime()
          this.form.arrivalDate = date
          this.form.arrivalMoment = moment
          // 更新默认接待人员
          this.form.receptionStaff = this.profile.userId
        })
      }
      if (this.isDetail) {
        this.getDetail()
      }
    },
  },
  computed: {
    title(){
      return this.isDetail ? '登记详情': '到店登记'
    },
    baseInfo() {
      return this.$common.getBaseInfo()
    },
    // 客户来源
    customerFlowSources() {
      return this.baseInfo.customerFlowSources
    },
    // 客户意向级别
    customerIntentionLevels() {
      return this.baseInfo.customerIntentionLevels
    },
    // 陪同情况
    customerAccompanyTypes() {
      return this.baseInfo.customerAccompanyTypes
    },
    // 到店目的
    customerArrivalPurposes() {
      return this.baseInfo.customerArrivalPurposes
    },
    isOtherReason() {
      return this.form.arrivalPurpose.length && this.form.arrivalPurpose.includes(CONSTANT_99)
    },
    isHasAccompany() {
      return this.accompanyTypeHasNum.includes(this.form.accompanyType)
    },
    arrivalMomentMaxTime() {
      if (new Date(this.form.arrivalDate) < new Date(dayjs().format('YYYY-MM-DD'))) {
        return '23:55'
      }
      return `${new Date().getHours()}:${new Date().getMinutes()}`
    },
  },
  created() {},
  methods: {
    // 获取详情信息
    getDetail() {
      this.$httpAuth.post("/v2/appCustomerFlowService/flowDetail", { 
        flowId: this.flowId,
        dealerId: this.profile.dealerId
      }).then(e => {
        this.form = { ...this.form, ...this.formatForm(e?.data?.data ?? {}) }
        if (this.form.mobile && !this.isDetail) {
          // 到店信息验
          this.verifyArrival(this.form.mobile)
        }
      })
    },
    formatForm(result) {
      const form = result;
      form.intentionLevel = this.getDefaultValue(result.intentionLevel)
      form.reservationStaff = this.getDefaultValue(result.reservationStaff)
      const { date, moment } = this.getFormatTime(result.arrivalTimeStr);
      form.arrivalDate = date
      form.arrivalMoment = moment
      form.arrivalPurpose = result.arrivalPurpose ? result.arrivalPurpose.split(',').map(item =>Number(item)) : []
      form.arrivalType = result.arrivalType || CONSTANT_1
      return form
    },
    getDefaultValue(value){
      return value === 0 || value === '' ? null : value
    },
    handleChangeArrivalDate(value) {
      // 到店时间不能大于当前时间
      if (value === dayjs().format('YYYY-MM-DD') && this.form.arrivalMoment && new Date(`${value} ${this.form.arrivalMoment}`) > new Date()) {
        const { moment: arrivalMoment } = getDateTime()
        this.form.arrivalMoment = arrivalMoment
      }
    },
    getFormatTime(timeStr){
      if (!timeStr) {
        return {
          date: '',
          moment: ''
        }
      }
      const result = timeStr.split(' ')
      if (result.length < 2) {
        throw new Error('时间格式不正确');
      }
      return {
        date: result[0],
        moment: result[1].slice(0,5)
      }
    },
    handleChangeAccompanyType() {
      this.form.accompanyNum = this.isHasAccompany ? (this.form.accompanyNum || CONSTANT_1) : null
    },
    // 根据手机号查询到店类型、接待人员等信息
    handleChangeMobile(e) {
      if (e.length === 11 && mobileReg.test(e)) {
        this.verifyArrival(e);
      }
    },
    // 更改手机号，更新校验
    handleUpdateMobile() {
      if (this.form.mobile.length !== 11 || !mobileReg.test(this.form.mobile)) {
        this.$message.error('请输入正确的手机号！')
        // 重置到店信息
        this.form.arrivalType = CONSTANT_1
        this.form.receptionStaff = this.profile.userId
        this.form.customerId = CONSTANT_0// 无客档id，默认传0
        this.verifyArrivalInfo = {}
      }
    },
    // 到店信息验
    verifyArrival(mobile) {
      this.$httpAuth.post("/v2/appCustomerFlowService/verifyArrival", { 
        mobile,
        dealerId: this.profile.dealerId
      }).then(e => {
        this.verifyArrivalInfo = e?.data?.data ?? {}
        const { arrivalType, customerManagerName, customerManagerId, customerId, gender, name, wechat } = this.verifyArrivalInfo
          // this.form.arrivalType = arrivalType
          this.form.customerId = customerId
          this.form.receptionStaff = customerManagerName&&customerManagerId ? customerManagerId : this.profile.userId
          if (!this.form.name && name) {
            this.form.name = name
          }
          if (!this.form.gender && gender) {
            this.form.gender = gender
          }
          if (!this.form.wechat && wechat) {
            this.form.wechat = wechat
          }
          this.handleFlowCustomerInfo(mobile)
        })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('change', false)
    },
    handleLeaveRegister() {
      // canRegisterLeave 有权限跳转离店登记 0：否 1：是
      if (this.verifyArrivalInfo.canRegisterLeave === CONSTANT_1) {
        this.handleClose()
        this.canLeaveRegister = false
        this.$emit('leaveRegister', this.verifyArrivalInfo)
      } else {
        this.$message.error('该成员有接待中的记录')
      }
    },
    handleConfirm() {
      // 有到店接待记录且未离店 
      // inReception 是否有接待中的记录。1：是 2：否
      // canRegisterLeave 是否有接待中的记录。0：否 1：是
      if (this.verifyArrivalInfo.inReception === CONSTANT_1) {
        this.canLeaveRegister = true;
        return
      }
      if (dayjs(this.form.arrivalDate).isBefore(dayjs().subtract(6, 'day').format('YYYY-MM-DD'))) {
        this.$message.error('客流到店时间需要限制在7天内，请重新选择')
        return
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          // 到店登记
          await this.handleRegisterArrival()
          this.$emit('change', false)
          setTimeout(() => {
            this.isSubmitting = false
          }, 1000);
        }
      })
    },
    getArrivalParams() {
      const { 
        name,
        gender,
        mobile,
        wechat,
        arrivalType,
        accompanyType,// 陪同情况
        accompanyNum, // 陪同人数
        arrivalDate,// 到店时间
        arrivalMoment,// 到店时间
        reservationStaff,// 预约人员
        receptionStaff,// 接待人员
        arrivalPurpose,// 到店目的
        otherPurpose,// 其他目的
        customerId=CONSTANT_0,
      } = this.form;
      return {
        name,
        gender,
        mobile,
        wechat,
        arrivalType,
        accompanyType,
        accompanyNum,
        arrivalTime: `${arrivalDate} ${arrivalMoment}`,
        reservationStaff,
        receptionStaff,
        arrivalPurpose: arrivalPurpose.toString(),
        otherPurpose,
        dealerId: this.profile.dealerId,
        customerId
      }
    },
    // 到店登记
    handleRegisterArrival() {
      const params = this.getArrivalParams();
      return new Promise((resolve, reject) => {
        try {
          this.$httpAuth.post("/v2/appCustomerFlowService/registerArrival", params).then(e => {
            if (e?.data?.code === 1) {
              this.$message.success(e.data.detail||'登记成功')
              this.$emit('updateList')
            }
            resolve()
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 根据手机号获取客流对应的客档详情
    handleFlowCustomerInfo(mobile) {
      this.$httpAuth.post("/v2/appCustomerFlowService/getFlowCustomerInfo", { 
        mobile,
        dealerId: this.profile.dealerId
      }).then(e => {
        const data = e?.data?.data ?? {}
        if (data.name) {
          this.isGetCustInfoByPhone = true
          this.form.arrivalType = this.verifyArrivalInfo.arrivalType
        } else {
          this.isGetCustInfoByPhone = false
          this.form.arrivalType = null
          // this.form.name = ''
          // this.form.gender = null
          this.customerArrivalTypes = this.baseInfo.customerArrivalTypes.filter(item => item.dataValue === 1 || item.dataValue === 2)
        }
      })
    },
    handleVisibleChangeArrivalPurpose(e) {
      if (!e && !this.form.arrivalPurpose.includes(CONSTANT_99)) {
        this.form.otherPurpose = ''
      }
    }
  }
}
</script>
<style scoped>
::v-deep .el-dialog {
  margin-top: 70px!important;
  max-height: 600px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid rgb(231, 231, 232);;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.02);
}

::v-deep .el-dialog__body {
  flex: 1;
  overflow: auto;
}

::v-deep .el-dialog__footer {
  border-top: 1px solid rgb(231, 231, 232);
  box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.04);
}

.el-input--mini {
  width: 260px;
}
.el-select--mini {
  width: 260px;
}

.form-title {
  font-size: 14px;
  font-weight: bolder;
  margin-bottom: 20px;
}

::v-deep .el-form-item {
  margin-bottom: 15px;
  margin-right: 0;
}

.form-item-half {
  width: 50%;
}

.el-radio + .el-radio {
  margin-top: 0;
}
/* 日期组件样式--start */
::v-deep .date-box {
  display: flex;
}
::v-deep .date-box .el-form-item {
  margin-right: 0;
}
.date-box ::v-deep .el-date-editor--data.el-input {
  width: 160px;
}
.date-box ::v-deep .el-date-editor--time-select.el-input {
  width: 140px;
}
.date-box ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 26px;
  padding-right: 26px;
  font-size: 12px;
}
.date-box ::v-deep .el-input__icon {
  width: 14px;
  line-height: 28px;
}
.date-box .separation {
  margin: 6px 10px 0;
}
/* 日期组件样式--end */

.register-info {
  margin: 20px 0;
}

.accompany-num-text {
  margin-left: 15px;
}
</style>